import Misc from "../misc";

const regexAccountNumber = /^[0-9]{4,17}$/;
const routingNumberRegex = /^[0-9]{9}$/;

export const getValidationErrors = (currentValue, property) => {
  const errors = [];
  switch (property) {
    case "firstName": {
      if (!currentValue) {
        errors.push("assignPopup.errors.fieldRequired");
        return errors
      }
      if (currentValue.length === 1) {
        errors.push("assignPopup.errors.shortName");
      } else if (currentValue.length > 50) {
        errors.push("assignPopup.errors.longName");
      }
      if (!/^[A-Z\s\'\-\&\.a-z]+$/.test(currentValue)) {
        errors.push("assignPopup.errors.nameIsIncorrect");
      }
      break;
    }
    case "email": {
      if (!currentValue) {
        errors.push("assignPopup.errors.fieldRequired");
        return errors
      }
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(currentValue)) {
        errors.push("assignPopup.errors.invalidEmail");
      }
      break;
    }
    case "postal": {
      if (!currentValue) {
        errors.push("assignPopup.errors.fieldRequired");
        return errors
      }
      if (!Misc.isZip(currentValue)) {
        errors.push("assignPopup.errors.incorrectPostal");
        return errors
      }
      break;
    }
    case "phone2": {
      if (currentValue.length > 20) {
        errors.push("assignPopup.errors.phoneNumberIsTooLong");
      }
      break;
    }
    case "phoneNumber": {
      if (!currentValue) {
        errors.push("assignPopup.errors.phoneRequired");
        return errors
      }
      if (!Misc.isPhoneNumber(currentValue)) {
        errors.push("assignPopup.errors.phoneIncorrect");
      }
      break;
    }
    case "city":
    case "state": {
      if (!currentValue) {
        errors.push("assignPopup.errors.fieldRequired");
        return errors
      }
      break;
    }
    case "accountNumber": {
      if (!currentValue) {
        errors.push("assignPopup.errors.fieldRequired");
        return errors
      }
      if (!regexAccountNumber.test(currentValue)) {
        errors.push("paymentPopup.errors.accountNumber");
        return errors
      }
      break;
    }
    case "routingNumber": {
      if (!currentValue) {
        errors.push("assignPopup.errors.fieldRequired");
        return errors
      }
      if (!routingNumberRegex.test(currentValue)) {
        errors.push("paymentPopup.errors.routingNumber");
        return errors
      }
      break;
    }
    case "cardNumber":
      if (!currentValue) {
        errors.push("assignPopup.errors.fieldRequired");
        return errors
      }
      if (!Misc.detectCardType(currentValue)) {
        errors.push("paymentPopup.errors.incorrectCardNumber");
        return errors
      }
      break;
    case "cardExpiryMonth": {
      if (!currentValue) {
        errors.push("paymentPopup.errors.required");
        return errors
      }
      if (!/\d{2}/.test(currentValue) || currentValue < 1 || currentValue > 12) {
        errors.push("paymentPopup.errors.invalidExpiryMonth");
        return errors
      }
      break;
    }
    case "cardExpiryYear": {
      if (!currentValue) {
        errors.push("paymentPopup.errors.required");
        return errors
      }
      const currentYearNumber = (new Date()).getFullYear();
      if (!/\d{2}/.test(currentValue) || +("20" + currentValue) < currentYearNumber) {
        errors.push("paymentPopup.errors.invalidExpiryYear");
        return errors
      }
      break;
    }
    case "cardCvv": {
      if (!currentValue) {
        errors.push("paymentPopup.errors.required");
        return errors
      }
      if (!/[0-9]{3,4}/.test(currentValue)) {
        errors.push("paymentPopup.errors.invalidCVV");
        return errors
      }
      break;
    }
  }
  return errors
}

export const validateCVV = (cvv, final) => {
  const cvvPattern = final ? regexCVVwithLength : regexCVV;
  return cvvPattern.test(+cvv);
}

export const formatCardNumber = (cardNumber) => {
  const cardType = Misc.detectCardType(cardNumber);

  if (cardType === "visa" || cardType === "mastercard" || cardType === "discover" || cardType === "jcb") {
    return cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
  }

  if (cardType === "amex") {
    return cardNumber.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3');
  }

  if (cardType === "diners") {
    return cardNumber.replace(/(\d{4})(\d{6})(\d{4})/, '$1 $2 $3');
  }

  if (cardType === "unionPay") {
    return cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
  }

  return cardNumber; // If no card type detected, return the number unformatted.
};
